import numbro from 'numbro';
import ruRuLanguageImport from 'numbro/dist/languages/ru-RU.min';

let initialized = false;

export function initNumbro(): void {
  if (initialized) return;
  const ruRuLanguage = ((ruRuLanguageImport as { default?: numbro.NumbroLanguage })?.default ??
    ruRuLanguageImport) as numbro.NumbroLanguage;
  numbro.registerLanguage(ruRuLanguage);
  numbro.setLanguage('ru-RU');

  initialized = true;
}


